import BaseAPI from "../api";

const path: string = "employees";
const app_path: string = "app-employees";

export interface employeeType {
  keyword?: string;
  page?: number;
  limit?: number;
  sortType?: string;
  sortBy?: string;
}
export interface createEmployeesTypes {
  title: string;
  employeeFirstname: string;
  employeeLastname: string;
  email: string;
  password: string;
  idRole: number;
  idDepartment: number;
  idPosition: number;
  tel: string;
  fax: string;
  employeeStatus: string;
  permission?: any
}
export interface updateEmployeesTypes {
  title: string;
  employeeFirstname: string;
  employeeLastname: string;
  email: string;
  idRole: number;
  idDepartment: number;
  idPosition: number;
  tel: string;
  fax: string;
  employeeStatus: string;
  password?: string;
  permission?: any
}

export class EmployeesApi extends BaseAPI {
  public static createEmployee(props: createEmployeesTypes): Promise<any> {
    return this.api.post(`${app_path}`, props).then((res) => res);
  }
  public static getEmployees(props: employeeType): Promise<any> {
    return this.api.get(`${app_path}`, { params: { ...props , limit:props?.limit ? props.limit : 10000 } }).then((res) => res);
  }
  public static getEmployeeDetail(idEmployee: number): Promise<any> {
    return this.api.get(`${app_path}/${idEmployee}`).then((res) => res);
  }
  public static updateEmployee(
    idEmployee: number,
    props: updateEmployeesTypes
  ): Promise<any> {
    return this.api.patch(`${app_path}/${idEmployee}`, props).then((res) => res);
  }

  static getAllEmployees(props: any): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } })
      .then((res) => res)
  }
  static getEmployee(idEmployee: number): Promise<any> {
    return this.api.get(`${path}/${idEmployee}`, {})
      .then((res) => res)
  }
}
